import React from "react";

import Container from "@mui/material/Container/Container";
import LinearProgress from "@mui/material/LinearProgress/LinearProgress";

import { useLoading } from "../../contexts/LoadingContext";

const LoadingIndicator: React.FC = () => {
  const { loading } = useLoading();

  return (
    <Container maxWidth="xl">
      {loading.isLoading() && (
        <LinearProgress
          color="primary"
          sx={{
            height: "1px",
            marginTop: "-1px",
            backgroundColor: "transparent",
            "& .MuiLinearProgress-bar": {
              opacity: 0.2,
            },
          }}
        />
      )}
    </Container>
  );
};

export default LoadingIndicator;
